import { ProviderMedicalRole } from '@uplift/types';

export const getSessionDuration = (medicalRole: ProviderMedicalRole) => {
  return medicalRole === ProviderMedicalRole.psychiatrist ? 30 : 60;
};
